module.exports = __webpack_public_path__ + "img/cash.0d2fbeba.png";